export const CHAT_STICKER_PREFIX = "%%BUROSOUL_STICKER_V1%%";
export const CHAT_CONTENT_CARD_PREFIX = "%%BUROSOUL_CARD_V1%%";

const MAX_STICKER_LENGTH = 16;
const MAX_CARD_TITLE_LENGTH = 140;
const MAX_CARD_SUBTITLE_LENGTH = 180;
const MAX_CARD_DESCRIPTION_LENGTH = 500;

const TYPE_LABELS = {
  literature: "Литература",
  book: "Литература",
  podcast: "Подкаст",
  podcast_episode: "Подкаст",
  episode: "Подкаст",
  test: "Тест",
};

const TYPE_ICONS = {
  literature: "📚",
  book: "📚",
  podcast: "🎙️",
  podcast_episode: "🎧",
  episode: "🎧",
  test: "📝",
};

function cleanString(value, maxLength = 1000) {
  const raw = String(value ?? "");
  let sanitized = "";
  for (let i = 0; i < raw.length; i += 1) {
    const code = raw.charCodeAt(i);
    if ((code >= 0 && code <= 31) || code === 127) continue;
    sanitized += raw[i];
  }
  return sanitized.trim().slice(0, maxLength);
}

function safeUrl(value) {
  const s = cleanString(value, 600);
  if (!s) return "";
  if (/^(?:javascript|vbscript|file|data:text\/html)/i.test(s)) return "";
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("/")) return s;
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(s)) return "";
  return s;
}

export function normalizeChatContentCard(card = {}) {
  if (!card || typeof card !== "object") return null;

  const type = cleanString(card.type || card.kind || "", 40).toLowerCase();
  const id = cleanString(card.id ?? card.contentId ?? card.entityId ?? "", 80);
  const title = cleanString(card.title || card.name || "", MAX_CARD_TITLE_LENGTH);
  if (!type || !title) return null;

  const subtitle = cleanString(card.subtitle || card.author || card.topic || card.category || "", MAX_CARD_SUBTITLE_LENGTH);
  const description = cleanString(card.description || card.summary || card.note || "", MAX_CARD_DESCRIPTION_LENGTH);
  const url = safeUrl(card.url || card.href || card.link || "");
  const actionLabel = cleanString(card.actionLabel || card.action || "Открыть", 48) || "Открыть";
  const imageUrl = safeUrl(card.imageUrl || card.coverUrl || card.cover || card.avatarUrl || "");

  return {
    type,
    id,
    title,
    subtitle,
    description,
    url,
    actionLabel,
    imageUrl,
    label: TYPE_LABELS[type] || "Рекомендация",
    icon: TYPE_ICONS[type] || "✨",
  };
}

export function buildChatStickerPayload(emoji) {
  const value = cleanString(emoji, MAX_STICKER_LENGTH);
  return value ? `${CHAT_STICKER_PREFIX}${value}` : "";
}

export function parseChatStickerPayload(text) {
  const raw = String(text ?? "").trim();
  if (!raw.startsWith(CHAT_STICKER_PREFIX)) return null;
  const emoji = cleanString(raw.slice(CHAT_STICKER_PREFIX.length), MAX_STICKER_LENGTH);
  if (!emoji) return null;
  return { emoji, type: "sticker" };
}

export function buildChatContentCardPayload(card) {
  const normalized = normalizeChatContentCard(card);
  if (!normalized) return "";
  return `${CHAT_CONTENT_CARD_PREFIX}${JSON.stringify(normalized)}`;
}

export function parseChatContentCardPayload(text) {
  const raw = String(text ?? "").trim();
  if (!raw.startsWith(CHAT_CONTENT_CARD_PREFIX)) return null;
  const payload = raw.slice(CHAT_CONTENT_CARD_PREFIX.length).trim();
  if (!payload) return null;
  try {
    return normalizeChatContentCard(JSON.parse(payload));
  } catch {
    return null;
  }
}

export function getVisibleChatText(text) {
  const raw = String(text ?? "");
  if (parseChatStickerPayload(raw) || parseChatContentCardPayload(raw)) return "";
  return raw;
}

export function getChatPayloadPreview(text) {
  const raw = String(text ?? "").trim();
  if (!raw) return "";

  const sticker = parseChatStickerPayload(raw);
  if (sticker) return `Стикер ${sticker.emoji}`;

  const card = parseChatContentCardPayload(raw);
  if (card) return `${card.label}: ${card.title}`;

  if (raw.includes(CHAT_CONTENT_CARD_PREFIX) || raw.startsWith("%%BUROSOUL_CARD")) {
    return "Рекомендация";
  }

  if (raw.includes(CHAT_STICKER_PREFIX) || raw.startsWith("%%BUROSOUL_STICKER")) {
    return "Стикер";
  }

  return raw;
}
